export enum WorkAgreementOrderField {
  Name = "Name",
  Start = "Start",
  End = "End",
  Discount = "Discount",
  Archived = "Archived",
}
